import React from "react";
import { useReactToPrint } from "react-to-print";
import { Box, Button, Container, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LinkValues, ResponseValues } from "../../../values/strings";
import { useCoreRequestProvider } from "../../../providers/RequestProvider";
import { useThemeProvider } from "../../../providers/ThemeProvider";
import { TransactionDetailsReceiptListViewComponent } from "../../listview/TransactionListViewComponent";
import { useLanguageProvider } from "../../../providers/LanguageProvider";
import QRCode from "react-qr-code";
import { PrintableElementComponent } from "../../elements/PrintableElementComponent";

export const TransactionContractCoreviewMainPageComponent = ({ urlParams }) => {
  const [TxDetails, setTxDetails] = React.useState();
  const { t, i18n } = useTranslation();
  const lang = useLanguageProvider();
  const theme = useThemeProvider();
  const coreRequest = useCoreRequestProvider();
  const printComponentRef = React.useRef();
  const handlePrint = useReactToPrint({
    content: () => printComponentRef.current,
  });

  React.useEffect(async () => {
    if (!TxDetails) {
      const data = await coreRequest.get(
        LinkValues.core.finance.transaction.details(),
        {
          txkey: urlParams.txaddress,
        }
      );
      setTxDetails((data.data && data.data.data) || null);
    }
  }, [TxDetails]);

  const buildReceipt = () =>
    !TxDetails ? (
      <></>
    ) : (
      <Container maxWidth="lg" disableGutters={true} ref={printComponentRef}>
        <PrintableElementComponent
          clientName={TxDetails[ResponseValues.clientName]}
          type={TxDetails[ResponseValues.makeConverted(ResponseValues.type)]}
          txid={TxDetails[ResponseValues.txid]}
          symbol={TxDetails[ResponseValues.token]}
          token={TxDetails[ResponseValues.makeConverted(ResponseValues.token)]}
          amount={TxDetails[ResponseValues.amount]}
          fee={TxDetails[ResponseValues.fee]}
          state={TxDetails[ResponseValues.makeConverted(ResponseValues.state)]}
          creationDate={TxDetails[ResponseValues.creationDate]}
          clientMobile={TxDetails[ResponseValues.clientMobile]}
          clientEmail={TxDetails[ResponseValues.clientEmail]}
          clientID={TxDetails[ResponseValues.clientID]}
          identityState={TxDetails[ResponseValues.identityState]}
          clientSignature={TxDetails[ResponseValues.clientSignature]}
          refund={TxDetails[ResponseValues.refund]}
          term={TxDetails[ResponseValues.term]}
          apy={TxDetails[ResponseValues.apy]}
          caption={TxDetails[ResponseValues.caption]}
        />
      </Container>
    );

  return (
    <div>
      <Box
        marginY={5}
        className={theme.styles.classes.componentsTransactionReceipt}
      >
        <Grid container item direction="column">
          <Grid container item direction="column">
            {buildReceipt()}
          </Grid>
          <Grid container item direction="row" padding={1} spacing={1}>
            <Grid container item direction="column" xs={12}>
              <Button
                color={"primary"}
                variant="contained"
                onClick={handlePrint}
                disableElevation
                disableRipple
              >
                <Typography variant="navBar">{t("downloadOrPrint")}</Typography>
              </Button>
            </Grid>
            <Grid container item direction="column" xs={6}>
              <Button
                color={"secondary"}
                variant="contained"
                href={LinkValues.routes.initLocale(
                  LinkValues.routes.base(false),
                  lang.supportedLanguages
                )}
                disableElevation
                disableRipple
              >
                <Typography variant="navBar">
                  {t("returnToMainPage")}
                </Typography>
              </Button>
            </Grid>
            <Grid container item direction="column" xs={6}>
              <Button
                color={"secondary"}
                variant="contained"
                href={LinkValues.schema.transactions(urlParams.txaddress)}
                disableElevation
                disableRipple
              >
                <Typography variant="navBar">{t("returnToApp")}</Typography>
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};
